import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TUser } from '@shared/interfaces/TUser';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { RegionsService, TRegion } from '../../services/regions.service';

@Component({
  selector: 'app-region-select',
  templateUrl: './region-select.component.html',
  styleUrls: ['./region-select.component.scss'],
})
export class RegionSelectComponent implements OnInit, OnDestroy {
  @Input() public regions: TRegion[] = [];
  @Input() public regionsFiltered: TRegion[] = [];
  @Input() public selectedRegions = new FormControl<TRegion[]>([]);
  @Input() public multiple = true;
  @Input() public handleRegionClick: (region: TRegion) => void = (region: TRegion) => {};
  regionFilterInput = new FormControl('');
  private _subs: Subscription[] = [];

  constructor(
    private _regionsService: RegionsService,
    private _authService: AuthService,
  ) {}

  public ngOnInit(): void {
    this._subs.push(
      this._regionsService.getRegionSelectorValues().subscribe((values) => {
        let filteredValues = values;
        // filter out regions not in user's countries
        const user = this._authService.getCurrentUser() as TUser;
        if (user?.countries?.length) {
          filteredValues = values.filter((region) => user.countries.includes(region.value));
        }
        this.regions = filteredValues;
        this.regionsFiltered = filteredValues;
      })
    );
  }

  public onRegionFilter(event: Event): void {
    const searchValue: string = (<HTMLInputElement>(
      event.target
    )).value.toLowerCase();
    this.regionsFiltered = this.regions.filter((option) =>
      option.value.toLowerCase().startsWith(searchValue)
    );
  }

  public compareRegions(r1: TRegion, r2: TRegion): boolean {
    return r1 && r2 ? r1.value === r2.value : r1 === r2;
  }

  protected resetRegionFilter() {
    this.regionFilterInput.patchValue('');
  }

  public hiddenClass(region: TRegion): { hidden: boolean } {
    return {
      hidden: !region.viewValue
        .toLowerCase()
        .includes(this.regionFilterInput.value?.toLowerCase() ?? ''),
    };
  }
  public ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
}
